import createMetadataAPITypes from '../../utils/api-metadata-types';

const actions = createMetadataAPITypes({ baseType: 'ACTIVE_PERIODS' });

export default {
  ...actions,
  CLEAR_ACTIVE_PERIODS: 'CLEAR_ACTIVE_PERIODS'
};
